export default __webpack_public_path__ + "static/media/scrabble-1920w.2fd4a24a.png";